// extracted by mini-css-extract-plugin
export default {"link":"banner_link__c+B2S","img":"banner_img__PunG+"};